import { Link } from 'react-router-dom';
import { Zap, Heart, ExternalLink, Rss } from 'lucide-react';
import { useAutomationPlatformTools } from '@/hooks/useTools';

export function Footer() {
  const { data: platformTools } = useAutomationPlatformTools();

  // Get dynamic links from database, with fallbacks
  const makeLink = platformTools?.make?.affiliate_link || 'https://www.make.com/en/register';
  const zapierLink = platformTools?.zapier?.affiliate_link || 'https://zapier.com/sign-up';
  const n8nLink = platformTools?.n8n?.affiliate_link || 'https://app.n8n.cloud/register';
  const lovableLink = platformTools?.lovable?.affiliate_link || 'https://lovable.dev';

  return (
    <footer className="border-t bg-card">
      <div className="container mx-auto py-12 px-4 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {/* Brand */}
            <div className="md:col-span-2">
              <Link to="/" className="flex items-center gap-2 mb-4">
                <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-primary">
                  <Zap className="h-5 w-5 text-white" />
                </div>
                <span className="font-semibold text-lg">Automation Recipes</span>
              </Link>
              <p className="text-muted-foreground text-sm max-w-md mb-4">
                Don't replace it. Automate it. Discover proven automation recipes
                to connect your existing tools and save hours every week.
              </p>
              {/* Built with Lovable */}
              <a
                href={lovableLink}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors group"
              >
                Built with <Heart className="h-3.5 w-3.5 text-red-500 fill-red-500" />
                <span className="font-medium text-foreground group-hover:text-primary">Lovable</span>
                <ExternalLink className="h-3 w-3 opacity-0 group-hover:opacity-100 transition-opacity" />
              </a>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="font-semibold mb-4">Quick Links</h4>
              <ul className="space-y-2 text-sm text-muted-foreground">
                <li>
                  <Link to="/recipes" className="hover:text-primary transition-colors">
                    Browse Recipes
                  </Link>
                </li>
                <li>
                  <Link to="/tools" className="hover:text-primary transition-colors">
                    Tool Directory
                  </Link>
                </li>
                <li>
                  <a
                    href="https://gidgcteopbvzxpqdvaur.supabase.co/functions/v1/rss"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-primary transition-colors inline-flex items-center gap-1"
                  >
                    <Rss className="h-3 w-3" />
                    RSS Feed
                  </a>
                </li>
              </ul>
            </div>

            {/* Automation Platforms */}
            <div>
              <h4 className="font-semibold mb-4">Automation Platforms</h4>
              <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                  <a
                    href={makeLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-primary transition-colors"
                  >
                    Make.com
                  </a>
                </li>
                <li>
                  <a
                    href={n8nLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-primary transition-colors"
                  >
                    n8n
                  </a>
                </li>
                <li>
                  <a
                    href={zapierLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-primary transition-colors"
                  >
                    Zapier
                  </a>
                </li>
              </ul>
            </div>
          </div>

        <div className="mt-12 pt-8 border-t text-center text-sm text-muted-foreground space-y-2">
          <p>
            © {new Date().getFullYear()} Automation Recipes. Built with ❤️ for
            automation enthusiasts.
          </p>
          <p className="text-xs text-muted-foreground">
            Some links on this site are affiliate links. We may earn a commission at no extra cost to you.
          </p>
        </div>
      </div>
    </footer>
  );
}